import { useNavigate } from 'react-router-dom'



function AddNewGrowingSeasonButton({farmId , map}) {
    const navigate = useNavigate()

    return (
        <div
            className={`flex overflow-visible w-fit items-center cursor-pointer hover:brightness-105 py-4 gap-4 text-right ${!map ? "text-agrotext" : "text-white"}  text-xl max-lg:text-[20px] font-semibold`}
            onClick={() => navigate(`/my-fields/field_certificate/${farmId}?reg=true`)}
        >
            افزودن فصل رشدی جدید
            <div className="addbtn pt-2 flex items-center justify-center w-10 h-10 rounded-full card-shadow text-agrotext">
                +
            </div>
        </div>
    )
}

export default AddNewGrowingSeasonButton